const webinarIdKeyName = 'ls.event.clickedWebinarId';

export default function EventCard(els) {
    els.forEach(el => {
        const lightboxButton = el.querySelector('[data-event="button"]');
        if (lightboxButton) {
            lightboxButton.addEventListener('click', () => {
                localStorage.setItem(webinarIdKeyName, el.dataset.webinarId);
                if (document.querySelector('[data-form-name*="webinar"]')) {
                    populateWebinarIdField();
                }
            });
        }
    });
}

export function populateWebinarIdField() {
    const webinarId = localStorage.getItem(webinarIdKeyName);
    const webinarIdInput = document.querySelector('input[name="webinar_id"]');
    if (webinarId && webinarIdInput) {
        webinarIdInput.value = webinarId;
    }
}
